module.exports = " <div class=\"leaflet-control control obs-map-context-info\"> <p class=ref-label>{{referenceLabel}}</p> <div class=\"val ref-val\">{{reference.name}} : {{referenceValue}}</div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/modules/observatoire/ng/maps/departement/obsDepartementMapContextInfo.html
// module id = 886
// module chunks = 2 11 12